import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type IAsset} from '@netx/core-asset-next/schema';
import {getResponseResults} from '@netx/core-next/utils/api';

/**
 * `getAssetObjects` request params\
 * (what is used to send to server)
 */
export type GetAssetObjectsRequestOptions = {
	ids: number[];
};

/**
 * `getAssetObjects` request\
 * (what gets sent to the server)
 */
export type GetAssetObjectsRequest = [GetAssetObjectsRequestOptions['ids']];

/**
 * `getAssetObjects` response\
 * (what comes back from the server)
 */
export type GetAssetObjectsResponse = SuccessResponse<GetAssetObjectsResult>;

/**
 * `getAssetObjects` result\
 * (what is utilized from the server response)
 */
export type GetAssetObjectsResult = IAsset[];

export const getAssetObjectsEndpoint = 'getAssetObjects';

/**
 * Get asset objects by ids
 * @param fetchParams Fetch params
 * @param signal Abort signal
 */
export const getAssetObjects = async (
	{ids}: GetAssetObjectsRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetAssetObjectsRequest = [ids];

	return client
		.post<GetAssetObjectsResponse>(getAssetObjectsEndpoint, requestParams, {
			signal,
		})
		.then(getResponseResults);
};

export default getAssetObjects;
